import { render, staticRenderFns } from "./europeAmerica.vue?vue&type=template&id=ba6b5a4e&scoped=true&"
import script from "./europeAmerica.vue?vue&type=script&lang=js&"
export * from "./europeAmerica.vue?vue&type=script&lang=js&"
import style0 from "./europeAmerica.vue?vue&type=style&index=0&id=ba6b5a4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6b5a4e",
  null
  
)

export default component.exports